// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalPoint_wrapper__Wvw6R"};